<template>
  <el-dialog
    :title="title"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    width="900px"
    :before-close="close"
    append-to-body
    custom-class="winner-workflow"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
      :rules="rules"
      size="small"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item
            prop="apiName"
            label="接口名称"
          >
            <el-input
              v-model.trim="form.apiName"
              placeholder="请输入接口名称"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="apiCode"
            label="接口编码"
          >
            <el-input
              v-model.trim="form.apiCode"
              placeholder="请输入接口编码"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="requestType"
            label="请求类型"
          >
            <el-select
              v-model="form.requestType"
              filterable
              placeholder="请选择请求类型"
              clearable
            >
              <el-option
                v-for="item in options"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="type"
            label="分类"
          >
            <el-select
              v-model="form.type"
              filterable
              placeholder="请选择分类"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            prop="microServicesName"
            label="微服务名"
          >
            <el-input
              v-model.trim="form.microServicesName"
              placeholder="请输入微服务名"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col
          :span="24"
          class="tipRow"
        >
          <div class="tip">
            如果服务在一个容器集群内，配置格式如下：<br>微服务名称.default:端口（如：http://supplier-relationship-xxx.default:9240/srm/procInst）
          </div>
          <div class="tip">
            如果服务不在一个容器集群内，配置格式如下：<br>配置完整的URL（如：http://k8s-prod.winnermedical.com/supplier-relationship-xxx/srm/procInst）
          </div>
        </el-col>
        <el-col :span="24">
          <el-form-item
            prop="url"
            label="接口地址"
          >
            <el-input
              v-model.trim="form.url"
              placeholder="请输入接口地址"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            prop="description"
            label="描述"
          >
            <el-input
              v-model.trim="form.description"
              type="textarea"
              placeholder="请输入描述"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button
        size="small"
        @click="close"
      >
        取 消
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="save"
      >
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import api from '@workflow/api/index.js'
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      isShow: false,
      loading: {
        save: false
      },
      form: {
        apiCode: '',
        apiName: '',
        description: '',
        operate: '',
        requestType: '',
        type: '',
        url: '',
        microServicesName: '',
        id: ''
      },
      rules: {
        apiCode: { required: true, message: '请输入接口编码', trigger: 'blur' },
        apiName: { required: true, message: '请输入接口名称', trigger: 'blur' },
        operate: { required: true, message: '请输入操作类型', trigger: 'blur' },
        requestType: { required: true, message: '请输入请求类型', trigger: 'change' },
        type: { required: true, message: '请输入类型', trigger: 'change' },
        url: { required: true, message: '请输入请求路径', trigger: 'blur' }
      },
      options: [
        'GET',
        'POST',
        'DELETE',
        'PUT',
        'HEAD',
        'CONNECT',
        'OPTIONS',
        'TRACE'
      ],
      typeOptions: [
        '节点获取审批人',
        '流程开始触发接口',
        '流程结束触发接口',
        '进入节点触发接口',
        '节点完成触发接口',
        '服务任务触发接口'
      ]
    }
  },
  computed: {
    title() {
      return this.isEdit ? '编辑HTTP API' : '新增HTTP API'
    },
    successMsg() {
      return this.isEdit ? '更新成功！' : '新增成功！'
    }
  },
  watch: {
    isOpen() {
      this.isShow = this.isOpen
      if (this.isShow) {
        if (this.isEdit) {
          this.form = { ...this.value }
        } else {
          this.form = {
            apiCode: '',
            apiName: '',
            description: '',
            operate: '',
            requestType: '',
            type: '',
            url: '',
            microServicesName: '',
            id: ''
          }
        }
      }
    }
  },
  methods: {
    save() {
      if (this.loading.save) return
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$message.error('请输入所有必填项')
        }
        this.loading.save = true
        api.httpApi.saveHttpApi(this.form).then(() => {
          this.$message.success(this.successMsg)
          this.clear()
          this.$emit('addSuccess')
        }).finally(() => {
          this.loading.save = false
        })
      })
    },
    close() {
      this.clear()
      this.$emit('close')
    },
    clear() {
      this.isShow = false
      this.$refs.form.clearValidate()
    }
  }
}
</script>
<style lang="scss" scoped>
.tipRow {
  margin-top: -15px;
  .tip {
    padding-left: 120px;
    font-size: 12px;
    color: #909399;
  }
}
</style>
